module.exports = __webpack_public_path__ + "smile.svg?47a67d30f53dd46c2b4947970f8c302b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feelings2/smile.svg
// module id = 91
// module chunks = 0